import { useCallback, useState } from "react";

export const useServerError = () => {
  const [serverError, setServerError] = useState<string | null>(null);

  const handleCleanError = useCallback(() => {
    setServerError(null);
  }, []);

  return { serverError, setServerError, handleCleanError };
};
